<template>
  <section class="hub-formats">
    <span class="hub-formats__eyebrow" v-html="getKeyValueListBlockValue(page, 'formats-details', 'eyebrow')"></span>
    <h2 class="hub-formats__title" v-html="getTitleBlock(page, 'formats', 'title')"></h2>
    <p class="hub-formats__description" v-html="getTitleBlock(page, 'formats', 'description')"></p>

    <div class="hub-formats__grid">
      <FormatCard v-for="card in cards" :key="card.group" :card="card" :page="page" />
    </div>
  </section>
</template>

<script>
import FormatCard from './format-card';
import { textBlock } from '@/entities/text-block';
import { RESOURCE_FORMAT_CARDS, RESOURCES_HUB_TEXT_PAGE } from '@/features/agent-resources/config';

export default {
  mixins: [ textBlock ],
  components: { FormatCard },
  data() {
    return {
      page: RESOURCES_HUB_TEXT_PAGE,
      cards: RESOURCE_FORMAT_CARDS,
    };
  },
};
</script>

<style lang="scss" scoped>
.hub-formats {
  max-width: 1328px;
  margin: 0 auto;
  padding: 140px 24px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 800px) {
    padding: 72px 16px 0;
  }

  &__eyebrow {
    padding: 12px 28px;
    border-radius: 999px;
    background: #EBF2FF;
    color: #4555CC;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: clamp(18px, 2vw, 24px);
    text-align: center;
  }

  &__title {
    margin: 20px 0;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(32px, 4vw, 52px);
    line-height: 1.15;
    text-align: center;
  }

  &__description {
    margin: 0 0 48px;
    max-width: 780px;
    font-size: 18px;
    line-height: 26px;
    color: #4E5358;
    text-align: center;
  }

  &__grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 24px;
  }
}
</style>
